import { render, staticRenderFns } from "./PengajuanFppkDetail.vue?vue&type=template&id=ad77e1a2&scoped=true"
import script from "./PengajuanFppkDetail.vue?vue&type=script&lang=js"
export * from "./PengajuanFppkDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad77e1a2",
  null
  
)

export default component.exports